const { useEffect } = require('react')

const useInitialValueToValidation = (value, validationFunction) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => validationFunction(value), [value])
}

export { useInitialValueToValidation }
